import Vue from "vue";
import routes from "./routes";
import Router from "vue-router";
import beforeEach from "./beforeEach";
import scrollBehavior from "./scrollBehavior";

Vue.use(Router);

const router = new Router({
  routes,
  mode: "history",
  scrollBehavior: scrollBehavior,
});
router.beforeEach(beforeEach);

export default router;
